// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tippy-box[data-theme~='globalTippyStyles'][data-animation='fade'][data-state='hidden'] {
   opacity: 0;
}
[data-tippy-root] {
   max-width: calc(100vw - 10px);
}
.tippy-box[data-theme~='globalTippyStyles'] {
   position: relative;
   background-color: #333;
   color: #fff;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.4;
   white-space: normal;
   outline: 0;
   transition-property: transform, visibility, opacity;
}
.tippy-box[data-theme~='globalTippyStyles'][data-placement^='top'] > .tippy-arrow {
   bottom: 0;
}
.tippy-box[data-theme~='globalTippyStyles'][data-placement^='top'] > .tippy-arrow:before {
   bottom: -7px;
   left: 0;
   border-width: 8px 8px 0;
   border-top-color: initial;
   transform-origin: center top;
}
.tippy-box[data-theme~='globalTippyStyles'][data-placement^='bottom'] > .tippy-arrow {
   top: 0;
}
.tippy-box[data-theme~='globalTippyStyles'][data-placement^='bottom'] > .tippy-arrow:before {
   top: -7px;
   left: 0;
   border-width: 0 8px 8px;
   border-bottom-color: initial;
   transform-origin: center bottom;
}
.tippy-box[data-theme~='globalTippyStyles'][data-placement^='left'] > .tippy-arrow {
   right: 0;
}
.tippy-box[data-theme~='globalTippyStyles'][data-placement^='left'] > .tippy-arrow:before {
   border-width: 8px 0 8px 8px;
   border-left-color: initial;
   right: -7px;
   transform-origin: center left;
}
.tippy-box[data-theme~='globalTippyStyles'][data-placement^='right'] > .tippy-arrow {
   left: 0;
}
.tippy-box[data-theme~='globalTippyStyles'][data-placement^='right'] > .tippy-arrow:before {
   left: -7px;
   border-width: 8px 8px 8px 0;
   border-right-color: initial;
   transform-origin: center right;
}
.tippy-box[data-theme~='globalTippyStyles'][data-inertia][data-state='visible'] {
   transition-timing-function: cubic-bezier(0.54, 1.5, 0.38, 1.11);
}
.tippy-box[data-theme~='globalTippyStyles'] .tippy-arrow {
   width: 16px;
   height: 16px;
   color: #333;
}
.tippy-box[data-theme~='globalTippyStyles'] .tippy-arrow:before {
   content: '';
   position: absolute;
   border-color: transparent;
   border-style: solid;
}
.tippy-box[data-theme~='globalTippyStyles'] .tippy-content {
   position: relative;
   padding: 5px 9px;
   z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./Shared/tippy-legacy-theme.css"],"names":[],"mappings":"AAAA;GACG,UAAU;AACb;AACA;GACG,6BAA6B;AAChC;AACA;GACG,kBAAkB;GAClB,sBAAsB;GACtB,WAAW;GACX,kBAAkB;GAClB,eAAe;GACf,gBAAgB;GAChB,mBAAmB;GACnB,UAAU;GACV,mDAAmD;AACtD;AACA;GACG,SAAS;AACZ;AACA;GACG,YAAY;GACZ,OAAO;GACP,uBAAuB;GACvB,yBAAyB;GACzB,4BAA4B;AAC/B;AACA;GACG,MAAM;AACT;AACA;GACG,SAAS;GACT,OAAO;GACP,uBAAuB;GACvB,4BAA4B;GAC5B,+BAA+B;AAClC;AACA;GACG,QAAQ;AACX;AACA;GACG,2BAA2B;GAC3B,0BAA0B;GAC1B,WAAW;GACX,6BAA6B;AAChC;AACA;GACG,OAAO;AACV;AACA;GACG,UAAU;GACV,2BAA2B;GAC3B,2BAA2B;GAC3B,8BAA8B;AACjC;AACA;GACG,+DAA+D;AAClE;AACA;GACG,WAAW;GACX,YAAY;GACZ,WAAW;AACd;AACA;GACG,WAAW;GACX,kBAAkB;GAClB,yBAAyB;GACzB,mBAAmB;AACtB;AACA;GACG,kBAAkB;GAClB,gBAAgB;GAChB,UAAU;AACb","sourcesContent":[".tippy-box[data-theme~='globalTippyStyles'][data-animation='fade'][data-state='hidden'] {\n   opacity: 0;\n}\n[data-tippy-root] {\n   max-width: calc(100vw - 10px);\n}\n.tippy-box[data-theme~='globalTippyStyles'] {\n   position: relative;\n   background-color: #333;\n   color: #fff;\n   border-radius: 4px;\n   font-size: 14px;\n   line-height: 1.4;\n   white-space: normal;\n   outline: 0;\n   transition-property: transform, visibility, opacity;\n}\n.tippy-box[data-theme~='globalTippyStyles'][data-placement^='top'] > .tippy-arrow {\n   bottom: 0;\n}\n.tippy-box[data-theme~='globalTippyStyles'][data-placement^='top'] > .tippy-arrow:before {\n   bottom: -7px;\n   left: 0;\n   border-width: 8px 8px 0;\n   border-top-color: initial;\n   transform-origin: center top;\n}\n.tippy-box[data-theme~='globalTippyStyles'][data-placement^='bottom'] > .tippy-arrow {\n   top: 0;\n}\n.tippy-box[data-theme~='globalTippyStyles'][data-placement^='bottom'] > .tippy-arrow:before {\n   top: -7px;\n   left: 0;\n   border-width: 0 8px 8px;\n   border-bottom-color: initial;\n   transform-origin: center bottom;\n}\n.tippy-box[data-theme~='globalTippyStyles'][data-placement^='left'] > .tippy-arrow {\n   right: 0;\n}\n.tippy-box[data-theme~='globalTippyStyles'][data-placement^='left'] > .tippy-arrow:before {\n   border-width: 8px 0 8px 8px;\n   border-left-color: initial;\n   right: -7px;\n   transform-origin: center left;\n}\n.tippy-box[data-theme~='globalTippyStyles'][data-placement^='right'] > .tippy-arrow {\n   left: 0;\n}\n.tippy-box[data-theme~='globalTippyStyles'][data-placement^='right'] > .tippy-arrow:before {\n   left: -7px;\n   border-width: 8px 8px 8px 0;\n   border-right-color: initial;\n   transform-origin: center right;\n}\n.tippy-box[data-theme~='globalTippyStyles'][data-inertia][data-state='visible'] {\n   transition-timing-function: cubic-bezier(0.54, 1.5, 0.38, 1.11);\n}\n.tippy-box[data-theme~='globalTippyStyles'] .tippy-arrow {\n   width: 16px;\n   height: 16px;\n   color: #333;\n}\n.tippy-box[data-theme~='globalTippyStyles'] .tippy-arrow:before {\n   content: '';\n   position: absolute;\n   border-color: transparent;\n   border-style: solid;\n}\n.tippy-box[data-theme~='globalTippyStyles'] .tippy-content {\n   position: relative;\n   padding: 5px 9px;\n   z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
